import http from "./http";

/* =============================
   ADD RAW MATERIAL
============================= */
export const addRawMaterial = async (payload) => {
  const res = await http.post("add-raw-material", {
    action: "add",
    name: payload.name,
    code: payload.code,
    category: payload.category,
    unit: payload.unit,
    consumption_check: payload.consumption_check,
    consumption_unit: payload.consumption_unit,
    conversion_rate: payload.conversion_rate,
    rate_per_unit: payload.rate_per_unit,
    rate_per_consumption_unit: payload.rate_per_consumption_unit,
    opening_stock: payload.opening_stock,
    alert_level: payload.alert_level,
  });
  return res.data;
};

/* =============================
   UPDATE RAW MATERIAL
============================= */
export const updateRawMaterial = async (id, payload) => {
  const res = await http.post("add-raw-material", {
    action: "update",
    id,
    name: payload.name,
    code: payload.code,
    category: payload.category,
    unit: payload.unit,
    consumption_check: payload.consumption_check,
    consumption_unit: payload.consumption_unit,
    conversion_rate: payload.conversion_rate,
    rate_per_unit: payload.rate_per_unit,
    rate_per_consumption_unit: payload.rate_per_consumption_unit,
    opening_stock: payload.opening_stock,
    alert_level: payload.alert_level,
  });
  return res.data;
};

/* =============================
   GET SINGLE RAW MATERIAL
============================= */
export const getRawMaterialById = async (id) => {
  const res = await http.post("add-raw-material", {
    action: "get",
    id,
  });
  return res.data;
};

/* =============================
   GET ALL RAW MATERIALS
============================= */
export const getRawMaterials = async () => {
  const res = await http.post("add-raw-material", {
    action: "get_all",
  });
  return res.data;
};

/* =============================
   ✅ DELETE RAW MATERIAL (FIX)
============================= */
export const deleteRawMaterial = async (id) => {
  const res = await http.post("add-raw-material", {
    action: "delete",
    id,
  });
  return res.data;
};
